import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import { randomBetween } from '../../../patient-profile-widget/utils/random-between';
import { LabeledSectionSkeleton } from '../labeled-section/labeled-section.skeleton';
import { AppointmentDate, AppointmentDateWrapper, AppointmentDetailsItem } from './appointment-details-section.styles';

export const AppointmentDetailsSectionSkeleton: FC = () => (
  <LabeledSectionSkeleton labelWidth={randomBetween(120, 160)}>
    <AppointmentDetailsItem>
      <AppointmentDateWrapper>
        <AppointmentDate>
          <Skeleton variant="text" width={120} height={15} />
        </AppointmentDate>
      </AppointmentDateWrapper>
      <Box sx={{ marginTop: '5px' }}>
        <Skeleton variant="text" width={randomBetween(70, 120)} height={15} />
      </Box>
      <Skeleton variant="rounded" width={90} height={18} sx={{ marginTop: '10px' }} />
    </AppointmentDetailsItem>
  </LabeledSectionSkeleton>
);
